import React from "react";
import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";

export default createSvgIcon(
  <React.Fragment>
    <path
      fillRule="evenodd"
      d="M18.307 5L20 6.277l-9.21 12.226L5 14.155l1.276-1.694 4.103 3.125z"
    />
  </React.Fragment>,
  `SelectIcon`
);
